import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/FAQ/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/FAQ/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/modules/faq.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/modules/hero_banner.module.scss");
